import React, { createContext, useContext, useMemo } from 'react';
import { platform } from '../../utils/platform.js';

var TUXContext = /*#__PURE__*/createContext({
  platform: platform,
  uniform: 'default'
});
TUXContext.displayName = 'TUXContext';
var useTUXContext = function useTUXContext() {
  return useContext(TUXContext);
};
var TUXProvider = function TUXProvider(_ref) {
  var children = _ref.children,
      _ref$platform = _ref.platform,
      platform$1 = _ref$platform === void 0 ? platform : _ref$platform,
      theme = _ref.theme,
      dir = _ref.dir,
      hasStatusBar = _ref.hasStatusBar,
      androidStatusBarHeight = _ref.androidStatusBarHeight,
      _ref$uniform = _ref.uniform,
      uniform = _ref$uniform === void 0 ? 'default' : _ref$uniform;
  var initialValue = useMemo(function () {
    return {
      platform: platform$1,
      dir: dir,
      theme: theme,
      hasStatusBar: hasStatusBar,
      androidStatusBarHeight: androidStatusBarHeight,
      uniform: uniform
    };
  }, [platform$1, dir, theme, hasStatusBar, androidStatusBarHeight, uniform]);
  return /*#__PURE__*/React.createElement(TUXContext.Provider, {
    value: initialValue
  }, /*#__PURE__*/React.createElement("div", {
    "data-theme": theme,
    dir: dir
  }, children));
};

export { TUXContext, TUXProvider, useTUXContext };
//# sourceMappingURL=TUXProvider.js.map
